import { useConsole } from "contexts/Console"

import Button from "../button/Button"
import { PopinContextProvider, usePopin } from "./PopinContextProvider"
import PopinEdito from "./PopinEdito"
import { waTriggerEvent } from "components/analytics/DigitalDataLayer"
import { Suspense } from "react"

function PopBtn({ children, icon, style, label, aria_label, theme, describedBy, className, isHubGrid, handlePress, stylesForCFI, triggerFormItEvent, pid }) {
  const cl = style || "icon translucent-dark"
  const clName = theme ? `${className} ${theme} ${cl}` : `${className} ${cl}`
  const { onOpen } = usePopin()
  const handlePopin = () => {
    onOpen()
    handlePress?.()
    if (isHubGrid)
      waTriggerEvent({
        eventType: "Click",
        eventName: "rftcClicked",
      })
    else if (triggerFormItEvent) {
      waTriggerEvent({
        eventName: "formOpened",
        eventType: "Click",
      })
    }
  }

  return !stylesForCFI ? (
    <Button
      className={clName}
      aria-haspopup='dialog'
      aria-controls={pid}
      aria_label={aria_label}
      onPress={handlePopin}
      icon={icon || "plus"}
      aria_describedby={describedBy}
    >
      {children}
      {label}
    </Button>
  ) : (
    <button
      type='button'
      aria-haspopup='dialog'
      aria-controls={pid}
      className={clName}
      aria-label={aria_label}
      aria_describedby={describedBy}
      onClick={handlePopin}
    >
      {label}
    </button>
  )
}

export default function PopinButton({
  children,
  icon,
  iconColor,
  style,
  stylesForCFI,
  label,
  aria_label,
  theme,
  preload,
  reference,
  describedBy,
  className,
  isHubGrid,
  triggerFormItEvent,
  handlePress,
  hasNoGestur = false,
}) {
  const console = useConsole()
  const uid = reference?.[0]?.uid
  const pid = `popup_${uid ?? ""}`

  console.verbose("PopinButton(%o)", { uid })
  return (
    uid && (
      <Suspense fallback={null}>
        <PopinContextProvider background={reference[0].background} hasNoGestur={hasNoGestur} uid={uid} preload={preload}>
          <PopBtn
            className={className}
            label={label}
            theme={theme}
            style={style}
            stylesForCFI={stylesForCFI}
            icon={icon}
            iconColor={iconColor}
            aria_label={aria_label}
            describedBy={describedBy}
            handlePress={handlePress}
            isHubGrid={isHubGrid}
            triggerFormItEvent={triggerFormItEvent}
            pid={pid}
          >
            {children}
          </PopBtn>
          <PopinEdito label={aria_label} pid={pid} />
        </PopinContextProvider>
      </Suspense>
    )
  )
}
